import { Controller } from "@hotwired/stimulus";
import { patch } from "@rails/request.js";

export default class extends Controller {
  static targets = ["emailInput", "phoneInput", "phoneSmsEnabledInput"];

  handleFormSubmit(event) {
    event.preventDefault();
    const primaryFormData = new FormData(document.querySelector("#new_outreach_event_form"));
    const secondaryFormData = new FormData(this.element);

    for (const [key, value] of secondaryFormData.entries()) {
      primaryFormData.set(key, value);
    }

    patch(this.element.action, {
      body: primaryFormData,
      responseKind: "turbo-stream",
    }).then((response) => {
      if (response.ok) {
        this.#handleFormSubmitCallbacks();
      }
    });
  }

  #handleFormSubmitCallbacks() {
    window.dispatchEvent(
      new CustomEvent("handleContactInfoChange", {
        detail: {
          email: this.emailInputTarget.value,
          phone: this.phoneInputTarget.value,
          phoneSmsEnabled: this.phoneSmsEnabledInputTarget.checked,
        },
      }),
    );
  }
}
